// Default values
export default {
  colors: {
    base: "#343D42",
    support1: "#3A88BA",
    support2: "#2E5A77",
    support3: "#4D5052",
    support4: "#103046",
    gray1: "#FAFAFA",
    gray2: "#EAEAEA",
    gray3: "#CBCBCB",
    facebookBlue: "#365899",
    messengerBlue: "#3A82F7",
    error: "#da3f51",
    success: "#00d1b2",
    info: "#c2e0ff",
    edit: "#B6B9EF",
    beige: "#f7f7f5"
  }
};



// WEBPACK FOOTER //
// ./src/utils/theme.js